import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpEvent,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { PageError } from '@components/layouts/error/page-error.interface';
import { ComunService } from '@services/comun.service';

@Injectable()
export class ErrorHandlerInterceptor implements HttpInterceptor {
  constructor(private router: Router, private comunService: ComunService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((e: HttpErrorResponse) => {
        const error = e.error.data;
        e.error.data = error;

        if (e.status >= 500 || e.status === 0) {
          const pageError: PageError = {
            title: 'Error ' + e.status,
            subtitle: 'Error del servidor',
            description: 'Inténtelo más tarde',
            subDescription: error,
            txtButton: 'Volver',
            hrefLink: 'https://www.zenitseguros.cl/',
          };

          this.router.navigateByUrl('/error', {
            state: { pageError },
          });
        }
        return throwError(e);
      })
    );
  }
}
